module.exports = __webpack_public_path__ + "static/img/10.a03f157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/10.png
// module id = D2zg
// module chunks = 0